import _sortBy from 'lodash/sortBy'

const INITIAL_DIRECTION = true

class Sortable {
  constructor({ items, defaultSortBy = undefined }) {
    this.items = items || []
    this.sortBy = defaultSortBy
    this.sortDirection = INITIAL_DIRECTION
  }

  get sortedItems() {
    if (this.sortBy == null) return this.items
    return this.sortDirection
      ? _sortBy(this.items, this.sortBy)
      : _sortBy(this.items, this.sortBy).reverse()
  }

  changeSort(newSortBy) {
    if (this.sortBy === newSortBy) {
      this.sortDirection = !this.sortDirection
    } else {
      this.sortBy = newSortBy
      this.sortDirection = INITIAL_DIRECTION
    }
  }
}

export default Sortable
